import React from "react";
import { COLOR_PRIMARY } from "../../constants/colors";

const IconList = ({ color = {COLOR_PRIMARY} }) => {
  return (
    <svg
      id="UI_icon_list_light"
      data-name="UI icon/list/light"
      xmlns="http://www.w3.org/2000/svg"
      width="31.5"
      height="21"
      viewBox="0 0 31.5 21"
    >
      <path
        id="Vector_567_Stroke_"
        data-name="Vector 567 (Stroke)"
        d="M0,1.75A1.75,1.75,0,0,1,1.75,0h21a1.75,1.75,0,0,1,0,3.5h-21A1.75,1.75,0,0,1,0,1.75Z"
        transform="translate(7)"
        fill={color}
      />
      <path
        id="Vector_568_Stroke_"
        data-name="Vector 568 (Stroke)"
        d="M0,1.75A1.75,1.75,0,0,1,1.75,0h21a1.75,1.75,0,0,1,0,3.5h-21A1.75,1.75,0,0,1,0,1.75Z"
        transform="translate(7 8.75)"
        fill={color}
      />
      <path
        id="Vector_569_Stroke_"
        data-name="Vector 569 (Stroke)"
        d="M0,1.75A1.75,1.75,0,0,1,1.75,0h21a1.75,1.75,0,0,1,0,3.5h-21A1.75,1.75,0,0,1,0,1.75Z"
        transform="translate(7 17.5)"
        fill={color}
      />
      <path
        id="Ellipse_180"
        data-name="Ellipse 180"
        d="M3.5,1.75A1.75,1.75,0,1,1,1.75,0,1.75,1.75,0,0,1,3.5,1.75Z"
        fill={color}
      />
      <path
        id="Ellipse_181"
        data-name="Ellipse 181"
        d="M3.5,1.75A1.75,1.75,0,1,1,1.75,0,1.75,1.75,0,0,1,3.5,1.75Z"
        transform="translate(0 8.75)"
        fill={color}
      />
      <path
        id="Ellipse_182"
        data-name="Ellipse 182"
        d="M3.5,1.75A1.75,1.75,0,1,1,1.75,0,1.75,1.75,0,0,1,3.5,1.75Z"
        transform="translate(0 17.5)"
        fill={color}
      />
    </svg>
  );
};

export default IconList;
